// Small labels (count, status) and toggle chips for filters. Always neutral: color belongs to changes and actions.
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Icon, type IconName } from './Icon';

type ChipProps = { children: ReactNode; icon?: IconName; to?: string };

export function Chip({ children, icon, to }: ChipProps) {
  const body = (
    <>
      {icon && <Icon name={icon} />}
      {children}
    </>
  );
  return to ? (
    <Link className="chip" to={to}>
      {body}
    </Link>
  ) : (
    <span className="chip">{body}</span>
  );
}

type ToggleChipProps = { children: ReactNode; pressed: boolean; onToggle: () => void };

/** A filter you can turn on and off. */
export function ToggleChip({ children, pressed, onToggle }: ToggleChipProps) {
  return (
    <button className="chip" type="button" aria-pressed={pressed} onClick={onToggle}>
      {children}
    </button>
  );
}

/** A chip that does something (play a word, pick a phrase). */
export function ChipButton({ children, onClick }: { children: ReactNode; onClick?: () => void }) {
  return (
    <button className="chip" type="button" onClick={onClick}>
      {children}
    </button>
  );
}
